import { IVariableFarmingTypeEnum } from "../../interfaces/IBovineVariables";

export const getBoundaryValue = (type: IVariableFarmingTypeEnum, value: number): string => {
    switch (type) {
        case IVariableFarmingTypeEnum.Slaughter:
            return resolveBoundaryForSlaughterVariable(value);
        case IVariableFarmingTypeEnum.Purchase:
            return resolveBoundaryForPurchaseVariable(value);
        default:
            return '';
    }
};

const resolveBoundaryForSlaughterVariable = (value: number): string => {
    if (value === 1) return 'AnelmaVariables:BirthWeight';
    else if (value === 2) return 'AnelmaVariables:SlaughterWeight';
    else if (value === 3) return 'AnelmaVariables:DailyGainFromBirth';
    else if (value === 6) return 'AnelmaVariables:EmptyingInterval';
    return '';
};

const resolveBoundaryForPurchaseVariable = (value: number): string => {
    if (value === 1) return 'AnelmaVariables:PurchaseWeight';
    else if (value === 2) return 'AnelmaVariables:DeliveryWeight';
    else if (value === 3) return 'AnelmaVariables:DailyGainFromDelivery';
    else if (value === 6) return 'AnelmaVariables:EmptyingInterval';
    return '';
};
